import React, { Component, PropTypes } from 'react';
import { AuthStore } from 'stores';
import {
  Styles,
  Dialog,
  Paper,
  RaisedButton,
  CircularProgress
} from 'material-ui';
import RegisterForm from 'components/RegisterForm';
import { FormattedMessage } from 'react-intl';
const { Spacing } = Styles;
import * as SvgIcons from 'components/Material/SvgIcons';
import * as Colors from 'components/Material/Styles/Colors';
import { InvitationActions, AuthActions } from 'actions';
import { history } from 'helpers';
import CountdownTimer from 'components/CountdownTimer';
import FullScreenDialog from 'components/FullScreenDialog';
import Css from 'Css';
import Loader from 'components/Material/Loader';
const { Units } = Css;

const css = oxygenCss({
  message: {
    textAlign: 'center',
    fontSize: 18,
    lineHeight: '26px',
    padding: Units.keyline,
    marginBottom: '-40px'
  }
});

export default class AcceptInvitation extends Component {
  static propTypes = {
    accepted: PropTypes.bool,
    loggedIn: PropTypes.bool,
    expired: PropTypes.bool,
    hash: PropTypes.string
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func,
    muiTheme: PropTypes.object
  };

  state = {
    accepted: false
  };

  componentWillReceiveProps(nextProps) {
    if (!this.props.loggedIn && nextProps.loggedIn) {
      InvitationActions.accept(this.props.hash);
    }
    if (nextProps.owner && nextProps.owner.locale !== this.props.locale) {
      AuthActions.setLocale(nextProps.owner.locale);
    }
  }

  accept = () => {
    if (this.props.loggedIn) {
      InvitationActions.accept(this.props.hash);
    }
  };

  redirect = () => {
    history.replace(`/dashboard`);
  };

  render() {
    const {
      loading,
      expired,
      accepted,
      loggedIn,
      usedByMe,
      accepting,
      used,
      email,
      owner,
      course,
      limit,
      count,
      hash
    } = this.props;
    if (loading) {
      return <Loader />;
    }

    let message = null;
    let emailMessage = null;

    if (expired) {
      message = this.context.getIntlMessage('invitation.expired');
      emailMessage = (
        <div>
          <a
            href={
              'mailto:' +
              owner.email +
              '?subject=Expired Invitation Link for Course: ' +
              course.name
            }>
            Click here
          </a>{' '}
          to contact the course creator for another link
        </div>
      );
    } else if (used && !usedByMe && limit <= 1) {
      message = this.context.getIntlMessage('invitation.used');
    } else if (accepted) {
      const color = Colors.Colors.green[500].material;
      message = (
        <div>
          <SvgIcons.NavigationCheck
            color={color}
            style={{ verticalAlign: 'middle' }}
          />
          {this.context.getIntlMessage('invitation.accepted')}
        </div>
      );
    } else if (!accepting && limit <= 1) {
      message = (
        <FormattedMessage
          message={this.context.getIntlMessage('invitation.acceptText')}
          email={this.props.email}
        />
      );
    }
    return (
      <FullScreenDialog
        padded
        title={this.context.getIntlMessage('invitation.accept')}
        overlay={false}
        open>
        {message && (
          <div className={css.message}>
            {message} <br />
            <br />
            {emailMessage}
          </div>
        )}
        {limit === count && (accepted || usedByMe) && (
          <div style={{ textAlign: 'center' }}>
            {this.context.getIntlMessage('invitation.redirectIncoming')}
            <br />
            <CountdownTimer
              seconds={3}
              color='#777'
              alpha={0.3}
              size={128}
              onComplete={this.redirect}
            />
          </div>
        )}
        {limit === count && !(accepted || usedByMe) && used && (
          <div style={{ textAlign: 'center' }}>
            {this.context.getIntlMessage('invitation.redirectLoginPage')}
            <br />
            <CountdownTimer
              seconds={4}
              color='#777'
              alpha={0.3}
              size={128}
              onComplete={this.redirect}
            />
          </div>
        )}

        {!loggedIn &&
          !expired &&
          (!used || count <= limit) &&
          !accepting &&
          (!accepted || count <= limit) && (
            <RegisterForm
              title={' '}
              ref='registerForm'
              hash={hash}
              userName={owner.username}
              userEmail={email}
              userLocale={owner.locale}
            />
          )}

        {accepting && (
          <div className={css.message}>
            <CircularProgress mode='indeterminate' />
          </div>
        )}
        {loggedIn && !accepted && !usedByMe && (
          <RaisedButton
            disabled={expired}
            fullWidth
            secondary
            label={this.context.getIntlMessage('Accept')}
            onTouchTap={this.accept}
          />
        )}
      </FullScreenDialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Invitation/AcceptInvitation.js